import React, { useState, useEffect } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ExpandableTable.css";
import Sortdownarrow from "../../IconComponents/Sortdownarrow";
import Sortuparrow from "../../IconComponents/Sortuparrow";
import Sortingarrow from "../../IconComponents/Sortingarrow";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import TableHeader from "./TableHeader/TableHeader";
import {
  Allassetcategory,
  getassetsubcategory,
  stafftype,
} from "../../../Services/EndPoints";
import { postDataWithBody, getData } from "../../../Services/Services";
import { toast } from "react-toastify";
import TaskModalWithComment from "../TaskModalWithComment/TaskModalWithComment";
import TaskModalWithCommentForResource from "../TaskModalWithComment/TaskModalWithCommentForResource";
import { Button, Modal } from "react-bootstrap";
import { XCircleblack } from "../../IconComponents"; // Import the XCircleblack icon

// Default filter UI for a column
const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // undefined to remove the filter entirely
      }}
      placeholder={`Filter...`}
      style={{
        width: "100%",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "5px",
      }}
    />
  );
};

// Confirmation popup component
const Confirmpopup = ({
  show,
  title,
  message,
  handleToggle,
  deleteRow,
  cancel,
  action,
}) => {
  if (!show) return null;

  return (
    <div className="confirm-popup-overlay">
      <div className="confirm-popup">
        <div className="confirm-popup-header">
          <h3>{title}</h3>
        </div>
        <div className="confirm-popup-body">
          <p>{message}</p>
        </div>
        <div className="confirm-popup-footer">
          <button className="cancel-button" onClick={handleToggle}>
            {cancel}
          </button>
          <button className="confirm-button" onClick={deleteRow}>
            {action}
          </button>
        </div>
      </div>
    </div>
  );
};

// Action Message Cell Component with Modal
const ActionMessageCell = ({ value, t }) => {
  const [showModal, setShowModal] = useState(false);
  const [fullMessage, setFullMessage] = useState("");
  const [highlightedMessage, setHighlightedMessage] = useState("");

  const handleShowModal = (message) => {
    setFullMessage(message);
    setHighlightedMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setHighlightedMessage("");
  };

  const messageText = value || "NA";
  const truncatedMessage =
    messageText.length > 25
      ? `${messageText.substring(0, 25)}...`
      : messageText;

  const isHighlighted = messageText === highlightedMessage;

  if (showModal) {
    setTimeout(() => {
      let el = document.querySelector(".modal-content");
      if (el) {
        el.style.cssText =
          "background-color: #1c2038 !important; border-radius: 20px !important;";
      }
    }, 0);
  }

  return (
    <span>
      <span
        title={messageText}
        style={{
          cursor: "pointer",
          backgroundColor: isHighlighted ? "#1a7a73" : "transparent",
          padding: "2px 5px",
          borderRadius: "5px",
        }}
        onClick={() => handleShowModal(messageText)}
      >
        {truncatedMessage}
      </span>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
        centered
        style={{
          borderRadius: "20px",
          border: "none",
          top: "20%",
        }}
      >
        <Modal.Header
          style={{
            backgroundColor: "#1a7a73",
            color: "white",
            borderBottom: "none",
          }}
        >
          <Modal.Title style={{ color: "white", marginRight: "200px" }}>
            Full Action Message
          </Modal.Title>
          <XCircleblack
            onClick={handleCloseModal}
            width="1.5em"
            height="1.5em"
            className="cursor-pointer"
          />
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "#fcfcfc",
            color: "#001b30",
            border: "none",
            padding: "20px",
            lineHeight: "1.8",
          }}
        >
          <p>{fullMessage}</p>
        </Modal.Body>
        <Modal.Footer
          style={{
            backgroundColor: "#fcfcfc",
            color: "white",
            borderTop: "none",
          }}
        >
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{
              backgroundColor: "#1a7a73",
              borderColor: "#003366",
              borderRadius: "5px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </span>
  );
};

// Status mapping constants
const STATUS_CODE_MAPPING = {
  768: "OPEN",
  769: "INPROGRESS",
  771: "COMPLETED",
};

// Map status text values back to codes
const STATUS_TEXT_TO_CODE = {
  OPEN: 768,
  INPROGRESS: 769,
  COMPLETED: 771,
};

// ResourceStatusDropdown component with fixed onStatusChange implementation
const ResourceStatusDropdown = ({
  resourceId,
  resourceType,
  currentStatus,
  onStatusChange,
  t,
  assignedTo,
  currentUserId,
  description,
  resourceData,
  getResourceList,
}) => {
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [newStatus, setNewStatus] = useState(null);
  const [showPop, setShowPop] = useState(false);
  const [taskData, setTaskData] = useState(null);

  const statusText =
    typeof currentStatus === "number"
      ? STATUS_CODE_MAPPING[currentStatus] || "OPEN"
      : currentStatus || "OPEN";

  const toggleConfirmPopup = () => {
    setShowConfirmPopup(!showConfirmPopup);
  };

  const showCompleteTaskPopup = () => {
    setShowPop(!showPop);
  };

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setNewStatus(selectedStatus);

    if (
      (statusText === "OPEN" && selectedStatus === "INPROGRESS") ||
      (statusText === "INPROGRESS" && selectedStatus === "COMPLETED")
    ) {
      setTaskData({
        id: resourceId,
        type: resourceType,
        currentStatus: statusText,
        newStatus: selectedStatus,
        description: resourceData?.description,
      });
      setShowPop(true);
    } else {
      toggleConfirmPopup();
    }
  };

  const confirmStatusChange = () => {
    if (newStatus && resourceId) {
      // Call the onStatusChange function passed from parent
      onStatusChange(resourceId, newStatus, resourceType);
    }
    toggleConfirmPopup();
  };

  const refreshTaskTable = () => {
    if (newStatus && resourceId) {
      // Call the onStatusChange function passed from parent
      onStatusChange(resourceId, newStatus, resourceType);
    }
    setShowPop(false);
  };

  const getDropdownColor = (status) => {
    // Handle both numeric status codes and text status values
    const statusKey =
      typeof status === "number" ? STATUS_CODE_MAPPING[status] : status;

    switch (statusKey) {
      case "OPEN":
        return "#f0a4ac";
      case "INPROGRESS":
        return "#fccd7c";
      case "COMPLETED":
        return "#7cdb90";
      default:
        return "gray";
    }
  };

  // Check if current user is assigned to this resource
  const isAssignedToCurrentUser =
    currentUserId && assignedTo && currentUserId === assignedTo;

  // If not assigned to current user, show status indicator instead of dropdown
  if (!isAssignedToCurrentUser) {
    const statusMap = {
      OPEN: { color: "#f0a4ac", label: t("Open") },
      INPROGRESS: { color: "#fccd7c", label: t("In Progress") },
      COMPLETED: { color: "#7cdb90", label: t("Closed") },
    };

    const status = statusMap[statusText];

    return status ? (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            width: "8px",
            height: "8px",
            backgroundColor: status.color,
            borderRadius: "50%",
          }}
        ></span>
        {status.label}
      </div>
    ) : (
      t("NA")
    );
  }

  // CSS for the custom select styling
  const selectStyle = {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    padding: "5px",
    paddingRight: "20px", // Space for the custom arrow
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: getDropdownColor(currentStatus),
    color: "black",
    width: "120px",
    position: "relative",
    cursor: "pointer",
  };

  // Create a wrapper div to position the arrow
  const wrapperStyle = {
    position: "relative",
    display: "inline-block",
  };

  // Arrow style
  const arrowStyle = {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "5px solid black",
    pointerEvents: "none", // Ensures clicks pass through to the select
  };

  return (
    <div>
      <div style={wrapperStyle}>
        <select
          value={statusText}
          onChange={handleStatusChange}
          style={selectStyle}
          className="status-dropdown"
        >
          <option value="OPEN" disabled={statusText !== "OPEN"}>
            {t("Open")}
          </option>
          <option value="INPROGRESS" disabled={statusText === "COMPLETED"}>
            {t("In Progress")}
          </option>
          <option value="COMPLETED" disabled={statusText !== "INPROGRESS"}>
            {t("Closed")}
          </option>
        </select>
        <div style={arrowStyle}></div>
      </div>

      {/* Task Modal with Comment - shown when changing status with required comment */}
      {showPop && (
        <TaskModalWithCommentForResource
          titleValue={t("actiontaken")}
          showSuccessMsg={refreshTaskTable}
          taskData={taskData}
          show={showPop}
          buttonLabel={t("popup.save")}
          handleToggle={showCompleteTaskPopup}
          getMyTaskList={refreshTaskTable}
          setShowPop={setShowPop}
          getResourceList={getResourceList}
        />
      )}

      {/* Regular confirmation popup for other status changes */}
      {showConfirmPopup && (
        <Confirmpopup
          show={showConfirmPopup}
          title={t("confirm")}
          message={t("confirmStatusChange")}
          handleToggle={toggleConfirmPopup}
          deleteRow={confirmStatusChange}
          cancel={t("cancel")}
          action={t("confirm")}
        />
      )}
    </div>
  );
};

// Main ExpandaleResource component with fixed status change handling
const ExpandaleResource = (props) => {
  const {
    columns,
    data,
    numberOfRows,
    headerTableHeadStyle = {},
    tableStyle = {},
    showRowCount = true,
    rowCount,
    tabChanger = false,
    activeTab,
    setActiveTab,
    searchData,
    setSearchData = () => {},
    enableColumnFilters = false,
    disbalePaginationFilter = false,
    disbalePaginationFilter1 = false,
    disbalePaginationFilter2 = false,
    resourceButton,
    resourceData,
    currentUserId,
    getResourceList,
    disableAddButton
  } = props;

  const [expandedRowIds, setExpandedRowIds] = useState({});
  const [assetCategoriesLoaded, setAssetCategoriesLoaded] = useState(false);
  const [assetcategory1, setassetcategory] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [staffTypes, setStaffTypes] = useState([]);
  const [loadedCategoryIds, setLoadedCategoryIds] = useState({});
  // Added state to trigger re-renders when status changes
  const [statusUpdateTrigger, setStatusUpdateTrigger] = useState(0);

  const toggleRowExpansion = (rowId) => {
    setExpandedRowIds((prev) => {
      const isCurrentlyExpanded = !!prev[rowId];
      return isCurrentlyExpanded ? {} : { [rowId]: true };
    });
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    rows,
    state: { pageIndex, globalFilter, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: numberOfRows },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { t } = useTranslation();

  const translateNumber = (number) => {
    const numberString = number.toString();
    return i18n.t(`numbers.${numberString}`, { defaultValue: numberString });
  };

  let tempRowCount = globalFilter ? rows.length : rowCount || data.length;
  let tempPageIndex = pageIndex;
  let tempPageSize = pageSize;

  if (tempPageIndex === undefined || tempPageIndex === null) {
    tempPageIndex = 0;
  }
  if (tempRowCount === undefined || tempRowCount === null) {
    tempRowCount = 0;
  }
  if (tempPageSize === undefined || tempPageSize === null) {
    tempPageSize = 10;
  }

  const startIndex = tempPageIndex * tempPageSize + 1 || 1;
  const endIndex =
    Math.min((tempPageIndex + 1) * tempPageSize, tempRowCount) || tempRowCount;

  const translatedStartIndex = startIndex;
  const translatedEndIndex = endIndex;
  const translatedRowCount = tempRowCount;

  useEffect(() => {
    setPageSize(numberOfRows);
  }, [numberOfRows]);

  useEffect(() => {
    if (globalFilter) {
      const pageData = page?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    } else {
      const pageData = rows?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    }
  }, [globalFilter, rows]);

  // Load staff types and asset categories once when component mounts
  useEffect(() => {
    fetchstaffdetails();

    // Only fetch asset categories if they haven't been loaded yet
    if (!assetCategoriesLoaded) {
      fetchcategory();
    }
  }, [assetCategoriesLoaded]);

  // This effect runs when expandedRowIds changes
  useEffect(() => {
    // For each expanded row, check if we need to load subcategories
    Object.keys(expandedRowIds).forEach((rowId) => {
      if (expandedRowIds[rowId]) {
        const row = rows.find((r) => r.id === rowId);
        if (
          row?.original?.requestType === "ASSET" &&
          row.original.asset_resource?.length > 0
        ) {
          const categoryId = row.original.asset_resource[0].assetCategoryId;

          // Only fetch subcategories if not already loaded for this category
          if (categoryId && !loadedCategoryIds[categoryId]) {
            fetchSubCategories(categoryId);
            setLoadedCategoryIds((prev) => ({ ...prev, [categoryId]: true }));
          }
        }
      }
    });
  }, [expandedRowIds, rows]);

  const fetchstaffdetails = async () => {
    try {
      let request = ["STAFF_CAT"];
      const response = await postDataWithBody(stafftype, request, {});
      if (Array.isArray(response)) {
        setStaffTypes(response);
      }
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  };

  const fetchcategory = async () => {
    try {
      let request = ["ASSET_CAT"];
      const response = await postDataWithBody(Allassetcategory, request, {});
      if (response && Array.isArray(response)) {
        setassetcategory(response);
        setAssetCategoriesLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching asset categories:", error);
    }
  };

  const fetchSubCategories = async (categoryId) => {
    try {
      const response = await getData(
        getassetsubcategory.replace("ID", categoryId)
      );
      if (Array.isArray(response)) {
        setSubCategories((prev) => {
          // Merge new subcategories with existing ones to avoid duplicates
          const newSubCategories = [...prev];
          response.forEach((newSubCategory) => {
            if (!newSubCategories.some((sc) => sc.id === newSubCategory.id)) {
              newSubCategories.push(newSubCategory);
            }
          });
          return newSubCategories;
        });
      }
    } catch (error) {
      console.error("Error fetching subcategories", error);
    }
  };

  const getCategoryName = (id) => {
    const category = assetcategory1.find((cat) => cat.id === id);
    return category ? category.value : "NA";
  };

  const getSubCategoryName = (id) => {
    const subCategory = subCategories.find((sub) => sub.id === id);
    return subCategory ? subCategory.value : "NA";
  };

  const getStaffNameById = (id) => {
    const staff = staffTypes.find((item) => item.id === id);
    return staff?.value || "NA";
  };

  // Helper function to get logged in user name (for API calls)
  const getLoggedInuserName = () => {
    return localStorage.getItem("userName") || "admin";
  };

  // Render expanded row content
 // Render expanded row content
const renderExpandedRow = (row) => {
  const original = row.original;

  return (
    <tr>
      <td colSpan="100%">
        <div
          style={{
            width: "100%",
            border: "1px solid white",
            borderRadius: "10px",
            marginTop: "10px",
            marginBottom: "10px",
            padding: "8px", // Add padding for better spacing
          }}
        >
          {original.requestType === "ASSET" &&
            original.asset_resource?.length > 0 && (
              <>
                <h5
                  style={{
                    textDecoration: "underline",
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "#1a7a73",
                    fontFamily: "Poppins",
                    marginBottom: "15px",
                  }}
                >
                  Asset Details
                </h5>
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      minWidth: "100%",
                      borderCollapse: "collapse",
                      tableLayout: "fixed", // Forces table to use full width
                      margin: "0",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#1a7a73" }}>
                        <th
                          style={{
                            width: "15%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Asset Name
                        </th>
                        <th
                          style={{
                            width: "15%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Asset Category
                        </th>
                        <th
                          style={{
                            width: "15%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Asset Type
                        </th>
                        <th
                          style={{
                            width: "12%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Quantity Required
                        </th>
                        <th
                          style={{
                            width: "12%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Non-Functional Units
                        </th>
                        <th
                          style={{
                            width: "18%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Action Message
                        </th>
                        <th
                          style={{
                            width: "13%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {original.asset_resource.map((asset, idx) => (
                        <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#f8f9fa" : "white" }}>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {asset.assetName || "NA"}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {getCategoryName(asset.assetCategoryId)}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {getSubCategoryName(asset.assetTypeId)}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {asset.quantity || 0}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {asset.nonFunctionalUnits || 0}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            <ActionMessageCell value={asset.actionMessage} t={t} />
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            <ResourceStatusDropdown
                              resourceId={asset.id}
                              resourceType="ASSET"
                              currentStatus={asset.status}
                              assignedTo={asset.assignedTo}
                              currentUserId={currentUserId}
                              resourceData={original}
                              getResourceList={getResourceList}
                              t={t}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

          {original.requestType === "STAFF" &&
            original.staff_resource?.length > 0 && (
              <>
                <h5
                  style={{
                    textDecoration: "underline",
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "#1a7a73",
                    fontFamily: "Poppins",
                    marginBottom: "15px",
                    marginTop: original.requestType === "ASSET" ? "25px" : "0",
                  }}
                >
                  Staff Details
                </h5>
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      minWidth: "100%",
                      borderCollapse: "collapse",
                      tableLayout: "fixed", // Forces table to use full width
                      margin: "0",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#1a7a73" }}>
                        <th
                          style={{
                            width: "16%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Staff Type
                        </th>
                        <th
                          style={{
                            width: "16%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Employment Type
                        </th>
                        <th
                          style={{
                            width: "16%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Experience Level
                        </th>
                        <th
                          style={{
                            width: "18%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Required Skill Set
                        </th>
                        <th
                          style={{
                            width: "20%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Action Message
                        </th>
                        <th
                          style={{
                            width: "14%",
                            padding: "12px 8px",
                            textAlign: "left",
                            borderBottom: "1px solid #ddd",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {original.staff_resource.map((staff, idx) => (
                        <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#f8f9fa" : "white" }}>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {getStaffNameById(staff.staffId)}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {staff.employmentType || "NA"}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {staff.expLevel || "NA"}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            {staff.skills || "NA"}
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            <ActionMessageCell value={staff.actionMessage} t={t} />
                          </td>
                          <td style={{ padding: "10px 8px", textAlign: "left", borderBottom: "1px solid #eee" }}>
                            <ResourceStatusDropdown
                              resourceId={staff.id}
                              resourceType="STAFF"
                              currentStatus={staff.status}
                              assignedTo={staff.assignedTo}
                              currentUserId={currentUserId}
                              resourceData={original}
                              getResourceList={getResourceList}
                              t={t}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
        </div>
      </td>
    </tr>
  );
};


  return (
    <div className="tabl_container">
      <TableHeader
        {...props}
        searchValue={globalFilter || ""}
        onSearchHandler={setGlobalFilter}
        resourceButton={resourceButton}
        disableresource={disableAddButton}
      />
      <div
        className="iccc__table--container"
        style={{ borderRadius: "0px", padding: "0px" }}
      >
        <table {...getTableProps()} className="table iccc--table">
          <thead style={{ backgroundColor: "#1a7a73" }}>
            <tr>
              <th
                style={{
                  width: "30px",
                  textAlign: "left",
                  color: "white",
                  backgroundColor: "#1a7a73",
                }}
              >
                {t("")}
              </th>
              {headerGroups.map((headerGroup, index) => (
                <React.Fragment key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={headerTableHeadStyle}
                      key={index}
                    >
                      {column.render("Header")}
                      {!column.disableSortBy &&
                        (column.isSorted ? (
                          column.isSortedDesc ? (
                            <Sortdownarrow />
                          ) : (
                            <Sortuparrow />
                          )
                        ) : (
                          <Sortingarrow />
                        ))}
                      {enableColumnFilters && column.canFilter && (
                        <div>{column.render("Filter")}</div>
                      )}
                    </th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                const isExpanded = expandedRowIds[row.id];

                return (
                  <React.Fragment key={row.id}>
                    <tr {...row.getRowProps()}>
                      <td style={{ textAlign: "left" }}>
                        <span
                          onClick={() => toggleRowExpansion(row.id)}
                          style={{ cursor: "pointer", fontSize: "18px" }}
                        >
                          {isExpanded ? "-" : "+"}
                        </span>
                      </td>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          key={cell.column.id}
                          style={{ textAlign: "left" }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                    {isExpanded && renderExpandedRow(row)}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="no-data-text">
                  No data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        {!disbalePaginationFilter2 && (
          <div className="float-start m-2 mt-2 ms-3">
            {showRowCount && (
              <div className="float-start m-2 mt-1 ms-3 pagecount-style">
                {t("showingentriestable.showing")} {translatedStartIndex}{" "}
                {t("showingentriestable.to")} {translatedEndIndex}{" "}
                {t("showingentriestable.of")} {translatedRowCount}{" "}
                {t("showingentriestable.entries")}
              </div>
            )}
          </div>
        )}
        <div className="pagination">
          {!disbalePaginationFilter && (
            <div className="d-flex">
              <span className="pagination_gotopage">
                Go to page:
                <input
                  type="number"
                  min="1"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    let pageNumber = Number(e.target.value);
                    if (pageNumber < 1 || isNaN(pageNumber)) {
                      pageNumber = 1; // Ensures minimum value of 1
                    }
                    gotoPage(pageNumber - 1);
                  }}
                  className="pagination_gotopage-input"
                />
              </span>
              <span>
                <select
                  className="pagination_select"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[10, 50, 100, 500, 1000, 2000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      show {pageSize}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          )}
          {!disbalePaginationFilter1 && (
            <>
              <button
                className="pagebtn mx-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>
              <button className="pagination_page">
                {translateNumber(pageIndex + 1)}{" "}
              </button>
              <button
                className="pagebtn"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <span className="right_pageno">
                {t("pagination.page_of", {
                  page: translateNumber(pageIndex + 1),
                  total: translateNumber(pageOptions.length),
                })}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpandaleResource;
